document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('li.site-nav__item.site-nav__expanded-item.site-nav--has-dropdown').forEach(function(item){
    item.addEventListener('click', function(e){
      e.preventDefault();
      document.querySelector('.header_pulldown').classList.add('down');
      document.body.classList.add('opn');
      document.querySelector('.overlay').style.display = 'block';

      let text = item.querySelector('a.site-nav__link').textContent;
      text = text.trim().toLowerCase().replace(' ', '-');
      console.log(text);
      if(text == 'learn-more') {
        document.querySelector('.menu_grandchild .lm').style.display = 'flex';
        document.querySelectorAll('.menu_grandchild > *:not(.lm)').forEach(el => el.style.display = 'none');
      } else if(text == 'shop') {
        document.querySelector('.menu_grandchild .shopp').style.display = 'flex';
        document.querySelectorAll('.menu_grandchild > *:not(.shopp)').forEach(el => el.style.display = 'none');
      }

      document.querySelectorAll('.menu_parent li').forEach(function(li){
        let parent = li.getAttribute('data-parent-link');
        li.style.display = (parent == text) ? 'block' : 'none';
      });
    });
  });

  document.querySelectorAll('.menu_parent li.non-dp').forEach(function(li){
    li.addEventListener('mouseenter', function(){
      let t = this.getAttribute('data-link');

      document.querySelectorAll('.menu_grandchild .header_product_block').forEach(function(block){
        let tt = block.getAttribute('data-link');
        block.style.display = (t == tt) ? 'block' : 'none';
      });
    });

    li.addEventListener('click', function(){
      let url = this.getAttribute('data-url');
      window.location.href = url;
    });
  });

  document.querySelector('.overlay')?.addEventListener('click', function(){
    document.querySelector('.header_pulldown').classList.remove('down');
    this.style.display = 'none';
  });

  document.querySelector('.announcement')?.addEventListener('click', function(){
    document.querySelector('.header_pulldown').classList.remove('down');
    document.querySelector('.overlay').style.display = 'none';
  });
});